import React from 'react';

import Translation from '@swf/components/Translation/Translation';

import type { DepositResult } from '../../../../../../types/Cashier';
import { isRedirectStatus } from '../../../../../../utils/cashier';
import RejectedCommon from '../RejectedCommon/RejectedCommon';

import { TXTWCL_WeXre_unable_to_process_your_r_ELL } from './Unknown.messages.json';

type Props = DepositResult;

const Unknown: React.FC<Props> = ({ status }) => {
  const isFinalStatus = !isRedirectStatus(status);

  return isFinalStatus ? (
    <RejectedCommon>
      <Translation {...TXTWCL_WeXre_unable_to_process_your_r_ELL} />
    </RejectedCommon>
  ) : null;
};
export default Unknown;
